export type NumericStatusEntry = {
  data: number;
  dateTime: Date;
};

export const STATUSDATA_MAX_DRIFT_MS = 10 * 60 * 1000;

function toTimestamp(value: Date | string | number) {
  return new Date(value).getTime();
}

/**
 * Binary search for the latest entry at or before `targetTime`, within `maxDriftMs`.
 * Entries must be sorted ascending by dateTime — callers own that invariant.
 */
export function getLatestStatusValueBefore(
  entries: NumericStatusEntry[],
  targetTime: number,
  maxDriftMs = STATUSDATA_MAX_DRIFT_MS,
): number | null {
  if (!entries.length || !Number.isFinite(targetTime)) return null;

  let left = 0;
  let right = entries.length - 1;
  let bestIndex = -1;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const midTime = toTimestamp(entries[mid].dateTime);

    if (midTime <= targetTime) {
      bestIndex = mid;
      left = mid + 1;
    } else {
      right = mid - 1;
    }
  }

  if (bestIndex < 0) return null;

  const matched = entries[bestIndex];
  const drift = targetTime - toTimestamp(matched.dateTime);
  return drift <= maxDriftMs ? matched.data : null;
}
